import {conditionsToString} from '../enums';
import {humanEnumeration, uppercaseFirstLetter} from '../utils';
import {toMonsterResist} from './to-monster-resist';

type ImmuneItem = {
	type: string;
	note?: string;
	special?: string;
	types?: string[];
};

function conditionTitle(type: string) {
	return conditionsToString(uppercaseFirstLetter(type || ''));
}

/** состояние ссылается на свою статью глоссария; её id — код состояния строчными буквами */
function toImmune(type: string) {
	const title = conditionTitle(type);
	if (!type || !title || title === 'Нет') return title;
	return `{@condition ${type.toLowerCase()}, ${title}}`;
}

export function toMonsterImmune(immune?: ImmuneItem[] | null, conditionImmune?: ImmuneItem[] | null) {
	const result = [];

	if (immune) result.push(toMonsterResist(immune));

	if (conditionImmune)
		result.push(
			conditionImmune
				.map((item) => {
					if (item.special) return {title: item.special, text: item.special};
					let text = '';
					let title = '';
					if (item.type) {
						text += toImmune(item.type);
						title += conditionTitle(item.type);
					}
					if (item.types) {
						text += humanEnumeration(item.types.map(toImmune), 'или');
						title += humanEnumeration(item.types.map(conditionTitle), 'или');
					}

					if (item.note) text += ` (${item.note})`;
					return {title, text};
				})
				// порядок по названию состояния, а не по разметке вокруг него
				.sort((first, second) => first.title.localeCompare(second.title, 'ru'))
				.map((item) => item.text)
				.join(', '),
		);
	return result.join('; ');
}
